// composables/useRoute.js
import { getCurrentInstance, computed } from 'vue'

export function useRoute() {
  const { proxy } = getCurrentInstance()

  // Computed para manter reatividade
  return computed(() => proxy.$route)
}
